"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringCase = void 0;
var StringCase;
(function (StringCase) {
    /** Camel case (camelCase) */
    StringCase["camelCase"] = "camelCase";
    /** Capital case (Capital Case) */
    StringCase["capitalCase"] = "capitalCase";
    /** Constant case (CONSTANT_CASE) */
    StringCase["constantCase"] = "constantCase";
    /** Dot case (dot.case) */
    StringCase["dotCase"] = "dotCase";
    /** Header case (Header-Case) */
    StringCase["headerCase"] = "headerCase";
    /** No case (no case) */
    StringCase["noCase"] = "noCase";
    /** Param case (param-case) */
    StringCase["paramCase"] = "paramCase";
    /** Pascal case (PascalCase) */
    StringCase["pascalCase"] = "pascalCase";
    /** Path case (path/case) */
    StringCase["pathCase"] = "pathCase";
    /** Sentence case (Sentence case) */
    StringCase["sentenceCase"] = "sentenceCase";
    /** Snake case (snake_case) */
    StringCase["snakeCase"] = "snakeCase";
})(StringCase = exports.StringCase || (exports.StringCase = {}));
